export default {
    name: '设置',
    permissionsKey:"YY-JS/QX",
    icon: 'fa fa-paper-plane',
    children: {
        adminRole:{
            name: '总后台管理员',
            permissionsKey:"YY-QGZXGLYSZ",
            path: '/role_permissions/admin_role',
        },
        studyCenterRole:{
            name: '学习中心管理员',
            permissionsKey:"YY-XXZXGLYSZ",
            path: '/role_permissions/study_center_role',
        },
        roleAndPermissions:{
            name: '角色/权限',
            permissionsKey:"YY-JS/QX-LI",
            path: '/role_permissions/role_and_permissions',
        },
    }
};
